import script from "./tax-auth-redirect.vue?vue&type=script&lang=ts&setup=true"
export * from "./tax-auth-redirect.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__